// Constant for Seller::Product::PriceConfirmation

export const STATUS = {
  PENDING             : 'pending',
  SELLER_CONFIRMED    : 'seller_confirmed',
  SELLER_DISAGREES    : 'seller_disagrees',
  SYSTEM_AUTO_CONFIRM : 'system_auto_confirm'
}
